import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fe5fccb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "centre main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Thanks for playing!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Here are your results once more. Feel free to share them!", -1))
const _hoisted_4 = { class: "results" }
const _hoisted_5 = {
  class: "guess-blocks",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Share results ")
const _hoisted_11 = {
  key: 1,
  class: "btn",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultList, (track, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass({correct: track.correct, partial: track.partial && !track.correct})
        }, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(track.guesses, (guess, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: _normalizeClass(`guess-${guess}`)
              }, null, 2))
            }), 128))
          ]),
          _createElementVNode("span", _hoisted_6, [
            (track.correct)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  class: "icon",
                  icon: ['far','check']
                }))
              : (track.partial)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    class: "icon",
                    icon: ['far','down-left-and-up-right-to-center']
                  }))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createTextVNode(_toDisplayString(track.title), 1),
            _hoisted_8,
            _createElementVNode("small", null, _toDisplayString(track.game), 1)
          ])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (!_ctx.copiedStatus)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
          }, [
            _hoisted_10,
            _createVNode(_component_font_awesome_icon, { icon: ['far','share-nodes'] })
          ]))
        : (_openBlock(), _createElementBlock("button", _hoisted_11, "Copied!")),
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, "Back")
    ])
  ]))
}